import { render, staticRenderFns } from "./FormTutorial.vue?vue&type=template&id=15aa1985"
import script from "./FormTutorial.vue?vue&type=script&lang=js"
export * from "./FormTutorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports